export default function MEACMembership() {
    return (
<div>
 <h4>Members</h4>

<p>
                  <b>Nicole Rahman</b>
                  <br/>
                  Term Expires: December 2027
                </p>
               
                <p>
                  <b>Vacant</b>
                  <br/>
                  Term Expires: December 2027
                </p>
                
                 <p>
                  <b>Gary Wallace</b>
                  <br/>
                  Term Expires: December 2028
                </p>
                 <p>
                  <b>Kim Lawton</b>
                  <br/>
                  Term Expires: December 2028
                </p>
                <p>
                  <b>Vacant</b>
                  <br/>
                  Term Expires: December 2029
                </p>
               
                </div>
                )
            }